/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      document.addEventListener( 'click', function( e ) {
        const toggle = e.target.closest( '.password-show' );
        if ( !toggle ) return;

        e.preventDefault();
        const input = toggle.previousElementSibling;
        if ( !input || input.tagName !== 'INPUT' ) return;

        const isShowing = toggle.classList.toggle( 'is-show' );
        input.type = isShowing ? 'text' : 'password';
      } );
      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      // const popupObserver = new MutationObserver( ( mutations ) => {
      //   mutations.forEach( ( mutation ) => {
      //     mutation.addedNodes.forEach( ( node ) => {
      //       if ( !( node instanceof HTMLElement ) ) return;

      //       const $popups = $( node ).filter( '.lifted-logic-popup-modal' )
      //           .add( $( node ).find( '.lifted-logic-popup-modal' ) );

      //       $popups.each( function() {
      //         const $popup = $( this );
      //         if ( $popup.find( '#book-now-popup__divider' ).length ) {
      //           const applyBorder = () => {
      //             const $firstSection = $popup.find( '[data-lifted-logic-popup-section]' ).first();
      //             if ( $firstSection.length ) {
      //               if ( window.innerWidth >= 768 ) {
      //                 $firstSection.css( {
      //                   'border-right': '1px solid #D9C08D',
      //                   'border-bottom': '',
      //                 } );
      //               } else {
      //                 $firstSection.css( {
      //                   'border-bottom': '1px solid #D9C08D',
      //                   'border-right': '',
      //                 } );
      //               }
      //             } else {
      //               setTimeout( applyBorder, 50 );
      //             }
      //           };

      //           applyBorder();

      //           $( window ).on( 'resize', applyBorder );
      //         }
      //       } );
      //     } );
      //   } );
      // } );

      // popupObserver.observe( document.body, {childList: true, subtree: true} );

      const updateBannerHeight = () => {
        if ( $( '.nav__cta-banner' ).length > 0 ) {
          const ctaBannerHeight = $( '.nav__cta-banner' ).outerHeight();
          document.documentElement.style.setProperty( '--ctaBannerHeight', `${ctaBannerHeight}px` );
        }
      };

      updateBannerHeight();
      window.addEventListener( 'resize', updateBannerHeight );

      const header = document.getElementById( 'navbar' );
      const primaryNav = document.getElementById( 'primary-nav' );
      const cta = document.getElementById( 'navbar__cta-btn' );
      const mainContent = document.querySelector( 'div.wrap #main-content' );
      if ( !header || !primaryNav || !cta || !mainContent ) return;

      const firstComponent = [...mainContent.children].find(
          ( el ) => el.nodeType === 1 && !el.matches( 'script, style' ),
      );
      const firstComponentIsJumpLinks = firstComponent && (
        firstComponent.matches( '.jump-links' ) ||
        firstComponent.dataset.component === 'jump-links'
      );

      function updateHeaderState() {
        const isScrolled = window.scrollY > 10;
        const isMenuOpen = primaryNav.classList.contains( 'is-open' );
        const forceBackground = header.dataset.forceBackground === 'true';

        if ( isScrolled || isMenuOpen || forceBackground || firstComponentIsJumpLinks ) {
          header.classList.remove( 'lg:bg-transparent' );
          header.classList.add( 'lg:bg-brand-charcoal' );
        } else {
          header.classList.remove( 'lg:bg-brand-charcoal' );
          header.classList.add( 'lg:bg-transparent' );
        }
      }

      updateHeaderState();

      window.addEventListener( 'scroll', updateHeaderState );

      const navObserver = new MutationObserver( updateHeaderState );
      navObserver.observe( primaryNav, {
        attributes: true,
        attributeFilter: ['class'],
      } );

      const handleFocusNav = function( navOpen ) {
        if ( navOpen ) {
          $( document ).on( 'keyup.navClose', function( event ) {
            if ( event.which === 27 ) {
              $( '.navbar-toggle' ).trigger( 'focus' ).trigger( 'click' );
            }
          } );
        } else {
          $( document ).off( 'keyup.navClose' );
        }
      };

      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
        if ( window.easyToggleState.isActive( event.target ) ) {
          $( 'body' ).addClass( 'overflow-hidden' );
          handleFocusNav( true );
        } else {
          $( 'body' ).removeClass( 'overflow-hidden' );
          handleFocusNav( false );
        }
      } );

      $( 'button.jump-links__easy-toggle-slide-toggle' ).on( 'toggleBefore', function( event ) {
        if ( window.innerWidth < 1024 ) {
          const target = $( this ).data( 'toggle-target' );
          $( target ).slideToggle();
        }
      } );

      $( 'button.easy-toggle-slide-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( target ).slideToggle();
      } );

      const addPhoneOverlay = () => {
        $( '#mobile-phone-navbar__overlay' ).toggleClass( 'is-open' );
      };

      $( '#mobile-phone__toggle' ).on( 'toggleAfter', ( event ) => {
        if ( window.matchMedia( '(max-width: 769px)' ).matches ) {
          addPhoneOverlay();
          $( '#ll-body' ).toggleClass( 'is-open' );
        }
      } );

      function clickFirstNavParentLink() {
        if ( window.innerWidth >= 1024 ) {
          const firstLink = document.querySelector( '.nav__parent-link' );
          if ( firstLink ) {
            firstLink.click();
          }
        }
      }

      clickFirstNavParentLink();

      window.addEventListener( 'resize', () => {
        clickFirstNavParentLink();
      } );
    },
    finalize: function() {},
    Throttle: class Throttle {
      constructor( callback, delay ) {
        this.callback = callback;
        this.delay = delay;
        this.throttlePause = false;
        this.waitingArgs = null;
        this.timeoutFunc = this.timeoutFunc.bind( this );
      }
      run( ...args ) {
        if ( this.throttlePause ) {
          this.waitingArgs = args;
          return;
        }
        this.callback( ...args );
        this.throttlePause = true;
        setTimeout( this.timeoutFunc, this.delay );
      }
      timeoutFunc() {
        if ( this.waitingArgs ) {
          this.callback( ...this.waitingArgs );
          this.waitingArgs = null;
          setTimeout( this.timeoutFunc, this.delay );
        } else {
          this.throttlePause = false;
        }
      }
    },
    Debounce: class Debounce {
      constructor( callback, time ) {
        this.callback = callback;
        this.time = time;
        this.debounceTimer;
      }
      run() {
        window.clearTimeout( this.debounceTimer );
        this.debounceTimer = window.setTimeout( this.callback, this.time );
      }
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
